import { styled } from "stitches.config";

export const Button = styled("button", {
  border: "none",
  outline: "none",
  cursor: "pointer",

  fontFamily: "$default",
  fontSize: "$1",
  fontWeight: "700",

  backgroundColor: "$gray200",
  color: "$gray300",
});
